import React from 'react';
import {Map} from 'immutable';
import {Atom} from '@packages/systems/wfdl';
import {lightRedBackground} from './Bootflow';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  CHECKOUT_STATES,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE,
} from '@packages/systems/commerce/constants';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import withAttribute from './withAttribute';
import {SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const shouldThisComponentBeShown = ({
  runtimeEnvironment,
  errorState,
}: {
  runtimeEnvironment: Environment;
  errorState: string;
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return errorState === CHECKOUT_STATES.ERROR;
  }
  return false;
};

const CommercePaypalCheckoutErrorState = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const runtimeEnvironment = useRuntimeEnvironment();
  const errorState = context.get('errorState');

  const styledAttributes = shouldThisComponentBeShown({
    runtimeEnvironment,
    errorState,
  })
    ? attributes
    : attributes.merge(styleDisplayNone);
  return (
    <div {...generateAttributes(styledAttributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  displayName: 'Error State',
  showEmpty: true,
  constraints: {
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommercePaypalCheckoutErrorMessage', rule: 'ExactlyOne'},
    ],
    ancestors: [...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(16),
          marginBottom: px(16),
          paddingTop: px(10),
          paddingRight: px(16),
          paddingBottom: px(10),
          paddingLeft: px(16),
          backgroundColor: lightRedBackground,
        },
      },
    },
  },
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE
  )(CommercePaypalCheckoutErrorState),
  fields: {children: TListOfElement},
});

export default config;
